module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/banner_header-070e78384e16f7b9aa613638e86f5e0b.png";